"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConnectedCameraPresenterSource = ConnectedCameraPresenterSource;
exports.ConnectedScreenPresenterSource = ConnectedScreenPresenterSource;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _Tile = require("../Tile");
var _reactRedux = require("react-redux");
var _utils = require("../../utils");
var _constants = require("../../constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ConnectedPresenterSource(_ref) {
  var source = _ref.source,
    type = _ref.type,
    isCameraOn = _ref.isCameraOn,
    style = _ref.style;
  var attendeeTiles = (0, _reactRedux.useSelector)(function (state) {
    return state.meeting.attendeeTiles;
  });
  var meetingSession = (0, _reactRedux.useSelector)(function (state) {
    return state.meeting.meetingSession;
  });
  var photo = source === null || source === void 0 ? void 0 : source.photo;
  var id = source._id;
  var user = _objectSpread(_objectSpread({}, (0, _utils.getSourceFirstNameLastName)(source === null || source === void 0 ? void 0 : source.title)), {}, {
    photo: photo,
    id: id
  });
  return _react["default"].createElement(_Tile.AttendeeTile, (0, _extends2["default"])({
    attendeeId: source.value
  }, {
    attendeeTiles: attendeeTiles,
    meetingSession: meetingSession
  }, {
    isCameraOn: isCameraOn,
    type: type,
    user: user,
    style: style
  }));
}
function ConnectedCameraPresenterSource(_ref2) {
  var source = _ref2.source,
    layer = _ref2.layer;
  return _react["default"].createElement(ConnectedPresenterSource, {
    source: source,
    type: _constants.CAMERA_PRESENTER,
    isCameraOn: layer.isCameraOn,
    style: layer.style
  });
}
function ConnectedScreenPresenterSource(_ref3) {
  var source = _ref3.source;
  return _react["default"].createElement(ConnectedPresenterSource, {
    source: source,
    type: _constants.SCREEN_PRESENTER
  });
}